import React, { useEffect } from 'react'
import ScenarioPanel from './ScenarioPanel'
import InstancesPanel from '../Instances/InstancesPanel'
import { getPermissions } from './actions'
import { INSTANCE_TYPE } from 'pages/Administration/constants'
import { useTranslation } from 'react-i18next'

const ScenarioTab = ({ admin }) => {
  const { roles, scenario } = admin
  const { t } = useTranslation(['Administration'])

  useEffect(() => {
    getPermissions()
  }, [])

  return (
    <div className='role-view'>
      <div className='children-view no-margin'>
        <ScenarioPanel roles={roles} scenario={scenario} />
      </div>
      <div className='children-view no-margin'>
        <h3 className='no-action-view'>
          {t('ScenarioManagement.TitleInstances')}
        </h3>
        <InstancesPanel admin={admin} instanceType={INSTANCE_TYPE.SCENARIO} />
      </div>
    </div>
  )
}

export default ScenarioTab
